/**
 * Boost Options Configuration
 * 
 * All available boost types for the Unified Boost Selection Modal.
 * Prices must match backend BOOST_COSTS in server.py
 */

export const BOOST_OPTIONS = [
  {
    id: "highlight_24h",
    code: "BOOST_HIGHLIGHT_24H",
    name_en: "Highlight 24h",
    name_ar: "تمييز 24 ساعة",
    price: 5,
    duration_hours: 24,
    description_en: "Highlighted background in listings",
    description_ar: "تمييز إعلانك بلون مختلف",
    icon: "highlight",
    color: "#F59E0B",
    ranking_bonus: 10,
  },
  {
    id: "urgent_7d",
    code: "BADGE_URGENT_7D",
    name_en: "Urgent Badge 7d",
    name_ar: "شارة عاجل 7 أيام",
    price: 3,
    duration_hours: 168, // 7 days
    description_en: "Adds urgent badge to your ad",
    description_ar: "إضافة شارة عاجل",
    icon: "urgent",
    color: "#EF4444",
    ranking_bonus: 5,
  },
  {
    id: "auto_refresh_24h",
    code: "AUTO_REFRESH_24H",
    name_en: "Auto Refresh 24h",
    name_ar: "تحديث تلقائي 24 ساعة",
    price: 10,
    duration_hours: 24,
    description_en: "Keeps ad at top automatically",
    description_ar: "يحافظ على إعلانك في الأعلى",
    icon: "refresh",
    color: "#3B82F6",
    ranking_bonus: 15,
  },
  {
    id: "top_category_24h",
    code: "BOOST_TOP_CATEGORY_24H",
    name_en: "Top of Category",
    name_ar: "أعلى القسم",
    price: 15,
    duration_hours: 24,
    description_en: "Pins your ad at top of category",
    description_ar: "تثبيت إعلانك أعلى القسم",
    icon: "top",
    color: "#8B5CF6",
    ranking_bonus: 25,
  },
  {
    id: "homepage_featured_24h",
    code: "BOOST_HOMEPAGE_24H",
    name_en: "Homepage Featured 24h",
    name_ar: "مُميز في الرئيسية 24 ساعة",
    price: 25,
    duration_hours: 24,
    description_en: "Show on homepage featured area",
    description_ar: "عرض إعلانك ضمن المميز في الرئيسية",
    icon: "home",
    color: "#10B981",
    ranking_bonus: 55,
  },
];

/**
 * Get boost option by id or code
 */
export function getBoostOption(idOrCode) {
  return BOOST_OPTIONS.find(opt => opt.id === idOrCode || opt.code === idOrCode);
}

/**
 * Apply regional pricing from backend to BOOST_OPTIONS
 * @param {Object} boostPricing - { BOOST_HIGHLIGHT_24H: 3, ... }
 * @returns {Array} BOOST_OPTIONS with updated prices
 */
export function applyRegionalPricing(boostPricing) {
  if (!boostPricing || typeof boostPricing !== 'object') return BOOST_OPTIONS;
  return BOOST_OPTIONS.map(opt => ({
    ...opt,
    price: boostPricing[opt.code] ?? opt.price,
  }));
}

/**
 * Get localized name for a boost option
 */
export function getBoostName(option, lang) {
  if (!option) return '';
  const isArabic = lang?.toLowerCase?.().startsWith('ar');
  return isArabic ? option.name_ar : option.name_en;
}

/**
 * Get localized description for a boost option
 */
export function getBoostDescription(option, lang) {
  if (!option) return '';
  const isArabic = lang?.toLowerCase?.().startsWith('ar');
  return isArabic ? option.description_ar : option.description_en;
}

/**
 * Format duration in user-friendly text
 */
export function formatDuration(hours, lang) {
  const isArabic = lang?.toLowerCase?.().startsWith('ar');
  
  if (hours >= 168) {
    const days = Math.floor(hours / 24);
    return isArabic ? `${days} أيام` : `${days} days`;
  } else if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return isArabic ? `${days} يوم` : `${days}d`;
  } else {
    return isArabic ? `${hours} ساعة` : `${hours}h`;
  }
}

export default BOOST_OPTIONS;
